import React from "react";
import _ from "lodash";
import { useParams } from "react-router-dom";
import useGames from "../../hooks/queryResults/useGames";
import useIsLoading from "../../hooks/queryResults/useIsLoading";
import useTeamLineups from "../../hooks/queryResults/useTeamLineups";
import useTeams from "../../hooks/queryResults/useTeams";
import useUserTeam from "../../hooks/queryResults/useUserTeam";
import Util from "../../util/util";
import LeagueWeekGames from "../league/LeagueWeekGames";
import WeekLinksBar from "../nav/WeekLinksBar";
import TeamBanner from "../team/TeamBanner";
import TeamLineup from "../team/TeamLineup";
import Loading from "../ui/Loading";

const getAwayAndHomeTeams = (g, teams) => {
  /** @type {string} */
  const awayTeamId = g.away?.team;
  /** @type {string} */
  const homeTeamId = g.home?.team;

  const away = awayTeamId ? teams.getTeamById(awayTeamId) : null;
  const home = homeTeamId ? teams.getTeamById(homeTeamId) : null;

  return { away, home };
};

const getGameFromGameUrl = (gamesData, teams, week, gameUrl) => {
  let game = null;
  let away = null;
  let home = null;
  if (gamesData?.games.hasOwnProperty(week)) {
    const games = gamesData.games[week];
    for (const id of Object.keys(games)) {
      const g = games[id];
      if (g.id === gameUrl) {
        game = g;
        break;
      }
      ({ away, home } = getAwayAndHomeTeams(g, teams));

      if (
        away &&
        gameUrl.includes(away.idOrSlug) &&
        home &&
        gameUrl.includes(home.idOrSlug)
      ) {
        game = g;
        break;
      }
    }
  }
  return { game, away, home };
};

const getGameFromTeamUrl = (gamesData, teams, week, teamUrl) => {
  let game = null;
  let away = null;
  let home = null;

  if (gamesData?.games.hasOwnProperty(week)) {
    const games = gamesData.games[week];
    for (const id of Object.keys(games)) {
      const g = games[id];

      ({ away, home } = getAwayAndHomeTeams(g, teams));

      if (
        (away && teamUrl === away.idOrSlug) ||
        (home && teamUrl === home.idOrSlug)
      ) {
        game = g;
        break;
      }
    }
  }
  return { game, away, home };
};

export default function GameMain() {
  const {
    league: leagueUrl,
    season: seasonUrl,
    week: weekUrl,
    game: gameUrl,
    team: teamUrl,
  } = useParams();
  const { teams, teamsQuery } = useTeams();
  const userTeam = useUserTeam();

  const week = Util.weekFromUrl(weekUrl);

  const { gamesData, gamesQuery } = useGames(week);

  let game = null,
    away = null,
    home = null;
  if (gameUrl)
    ({ game, away, home } = getGameFromGameUrl(
      gamesData,
      teams,
      week,
      gameUrl
    ));
  if (!game && teamUrl)
    ({ game, away, home } = getGameFromTeamUrl(
      gamesData,
      teams,
      week,
      teamUrl
    ));
  const gameTeams = { away, home };

  const {
    teamLineupsData: awayTeamLineupsData,
    teamLineupsQuery: awayTeamLineupsQuery,
  } = useTeamLineups(away, week);
  const {
    teamLineupsData: homeTeamLineupsData,
    teamLineupsQuery: homeTeamLineupsQuery,
  } = useTeamLineups(home, week);

  const isLoading = useIsLoading(
    gamesData,
    gamesQuery,
    teams,
    teamsQuery,
    userTeam,
    awayTeamLineupsData,
    awayTeamLineupsQuery,
    homeTeamLineupsData,
    homeTeamLineupsQuery
  );
  if (isLoading) return <Loading />;

  const getPredictedScore = (ah) => {
    const teamLineupsData =
      ah === "away" ? awayTeamLineupsData : homeTeamLineupsData;
    return teamLineupsData.teamLineups.weeks[week].spots
      .reduce((prev, spot) => {
        if (spot.startingPosition && spot.hasOwnProperty("lastFive")) {
          return prev + spot.lastFive;
        } else {
          return prev;
        }
      }, 0)
      .toFixed(2);
  };

  const weekLinksBarPath = `/${leagueUrl}/${seasonUrl}/${userTeam.idOrSlug}/game/:week`;

  return (
    <div>
      <LeagueWeekGames showWeekLinks={false} size={"sm"} />
      <WeekLinksBar path={weekLinksBarPath} />
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-evenly",
          width: "100%",
          marginTop: "1rem",
        }}
      >
        {["away", "home"].map((ah) => {
          const team = gameTeams[ah];
          const score = game?.[ah]?.score;
          let teamScore;
          if (
            !_.isUndefined(score) &&
            ((ah === "away" && score !== 0) || (ah === "home" && score !== 3))
          )
            teamScore = score;

          return (
            <div key={ah} style={{ width: "45%" }}>
              {team ? (
                <div>
                  <TeamBanner
                    team={team}
                    score={teamScore}
                    predictedScore={getPredictedScore(ah)}
                  />
                  <TeamLineup team={team} />
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
}
